"use client";
import { Dealer } from "../../lib/excelToJson"
import { RiGlobalLine, RiMapPinLine } from "@remixicon/react"

interface DealerCardProps {
	dealer: Dealer
}

const DealerCard: React.FC<DealerCardProps> = ({ dealer }) => {
	const isValidLocation = Array.isArray(dealer.location) && dealer.location.every(coord => coord !== null);
	console.log(dealer.website)

	return (
		<div className="grid gap-2">
			<div className="p-4 border rounded shadow-sm">
				<strong>{dealer.name}</strong>
				<p>{dealer.address}</p>
				<p>{dealer.state}</p>
				{dealer.contact && (<p>Contact : {dealer.contact}</p>)}
				{dealer.email && (<p>Email : {dealer.email} </p>)}
				<div className="flex gap-3 mt-2">
					{isValidLocation && (
						<a
							href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(dealer.name)}`}
							target="_blank"
							rel="noopener noreferrer"
							className="text-blue-500 hover:underline"
						>
							<RiMapPinLine
								size={20}
							/>
						</a>
					)}
					{dealer.website && (
						<a
							href={dealer.website}
							target="_blank"
							rel="noopener noreferrer"
							className="text-blue-500 hover:underline">
							<RiGlobalLine
								size={20}
							/>
						</a>
					)}
				</div>
			</div>
		</div>
	);
};

export default DealerCard;
